import React from 'react'
import ProjectItem from './ProjectItem';
import SideBar from './SideBar';

const data = [
    {
        id: 9,
        extra: false,
        title: 'TheBoringMarkets',
        company: '',
        started: '2025',
        isCompleted: true,
        image: './tbm.png',
        ended: '2025',
        description: "We fetch prices & headlines, then distills why moves may have happened — all tailored to your portfolio.",
        tags: ['Personal Project','Fintech'],
        tech: ['Typescript','React','TailwindCSS','Next.js', 'HTTP', 'Supabase', 'JavaScript'],
        fullDescription: null,
        link: 'https://theboringmarkets.vercel.app',
        github: 'https://github.com/imprakashraghu/crypto-know'
    },
    {
        id: 8,
        extra: true,
        title: 'Credit Card Analysis System',
        company: 'University of Windsor',
        started: '2024',
        isCompleted: true,
        ended: '2024',
        description: "Ranked among the best projects in the entire class. Scored 102% out of 100 based on extra efforts with the team.",
        tags: ['Academic Project','Credit Card Analaysis System'],
        tech: ['Java','React','TailwindCSS','CSV', 'HTTP', 'Web Scraping', 'JavaAPIs'],
        fullDescription: null,
        link: null,
        videoType: 'local',
        fullDescription: [
            'A credit card analysis system to analyze the credit card transactions and provide insights to the user.',
            'Implemented spelling check, word completion and frequency count algorithms in java',
            'Created HTTP request and response handling in java using OOPs concepts',
            'Developed a web application using React and Tailwind CSS to show the results to the user',
            'Written inverted indexing module and implemented the search functionality with the scraped data from different banking sites.',
        ],
        github: 'https://github.com/imprakashraghu/credit-card-analysis-system',
        videoType: 'youtube',
        video: 'https://www.youtube-nocookie.com/embed/Nw-249XCIZQ?si=zgxnwzJc2ANu7zg6'
    },
    {
        id: 7,
        extra: true,
        title: 'students.fyi',
        company: 'Personal Project',
        started: '2024',
        isCompleted: true,
        ended: '2024',
        description: "Runner up at Supabase Launch Week 13 Hackathon. Career path visualizer in a virtual map and career decisions simulator to see the consequences and get tips from AI to achieve those outcomes.",
        tags: ['Personal Project','Visualization Tool'],
        tech: ['JavaScript', 'NextJS','OpenAI','TailwindCSS','Supabase','Graph','PostgreSQL'],
        fullDescription: null,
        link: 'https://students-fyi.vercel.app',
        audio: false,
        videoType: 'youtube',
        video: 'https://www.youtube.com/embed/6sKLNyNNjUE?si=y_xL6mDWJv3MggAM'
    },
    {
        id: 6,
        extra: true,
        title: 'filterit',
        company: 'Academic Project',
        started: '2024',
        isCompleted: true,
        image: './filterit.png',
        ended: '2024',
        description: 'Open Source monitoring cum security tool to keep your data safe from public generative models, tools or services.',
        tags: ['Academic Project','Security Tool'],
        tech: ['Flask', 'Python','Machine Learning','React','MongoDB','Spacy(NER)'],
        fullDescription: null,
        github: 'https://github.com/imprakashraghu/filterit',
    },
    {
        id: 0,
        extra: true,
        title: 'listenade',
        company: 'Personal Project',
        started: '2021',
        isCompleted: true,
        image: './listenade.png',
        ended: '2021',
        description: 'A simple AI powered on-demand audio generation tool for podcasts. Everything here is automated using edge runtimes and get audios to your flutter app in minutes.',
        tags: ['Personal Project','AI Tool'],
        tech: ['Flutter','Android','IOS','Supabase','DenoJS'],
        fullDescription: null,
        link: '',
        videoType: 'youtube',
        video: 'https://www.youtube-nocookie.com/embed/_HwDnIhjPsY?controls=0'
    },
    {
        id: 1,
        extra: true,
        title: 'takecare',
        company: 'Tata Consultancy Services',
        started: '2021',
        isCompleted: true,
        image: null,
        ended: '2021',
        description: 'Winner of Season 4, National level contest conducted by Tata Consultancy Services. A cluster of applications working together to get the employee benefits using the data from the wearables.',
        tags: ['TCS Contest','National Hackathon'],
        tech: ['React','Android','NodeJS','Firebase','Python'],
        fullDescription: [
            'Created a cluster of applications including a web application using React and Ant Design CSS Framework, a server side application using NodeJS for simulation purposes and used python for basic machine learning predictions.',
            'Google Firebase is used as cloud service as database to store all parameters used in the application. It is a wearable based cluster where all data from simulated server and then processed to project into charts and graphs.',
            'Random normal and abnormal values are generated using algorithms written in javascript and passed through rest-apis using nodejs. These values are used to have a normal human healthy reading and vice versa.',
            'Android Mobile app was created using java and used to show predictions from machine learning algorithms and data processed into graphs and charts.'
        ],
        link: '',
        videoType: 'youtube',
        video: 'https://www.youtube-nocookie.com/embed/PrCxLuBFdpc?controls=0'
    },
    {
        id: 2,
        extra: true,
        title: 'hyderjs',
        company: 'HyderJS - JS UI Library',
        started: '2021',
        image: '/hyderjs.png',
        isCompleted: true,
        description: 'A fun project during undergrad, an open source light-weighted javascript web ui library built on top of ECMA Script 6, used to convert json to html.',
        ended: '2021',
        tags: ['Open Source','Personal Project'],
        tech: ['Javascript','JSON','Bootstrap','TailwindCSS'],
        fullDescription: [
            'It is an open source javascript library which is built on top of ECMA Script 6 created.',
            'It is a javascript library used to build wesbites with the help of JSON by creating a virutal dom and rendering it on the real dom. Instead of heavy html-markup we render your light weighted and structured json into required html. Note that you cannot use classes and inline styles at the same time.',
        ],
        link: 'https://hyder.js.org',
    },
    {
        id: 3,
        extra: true,
        title: 'protrack',
        company: 'Academic Project',
        started: '2018',
        isCompleted: true,
        ended: '2019',
        tags: ['Student','Project'],
        tech: ['React','NodeJS','Postgresql','CSS'],
        description: 'A simple academic project to manage student projects and update to professors',
        fullDescription: [
            'Created a student project tracking project to have regular updates to their respective mentors. Each have their own dashboards like professors, students and moderators.',
            'Web application was created using React, NodeJS and MongoDB. Ant Design CSS framework was used.',
            'It is a project named "Pro-Track" created for the department of Computer Science and Engineering.'
        ],
        link: null,
        videoType: 'local',
        video: './protrack-demo.mp4'
    },
    {
        id: 4,
        extra: true,
        title: 'Program Buddy Bot',
        company: 'Personal Project',
        started: '2022',
        isCompleted: true,
        image: null,
        ended: '2022',
        tags: ['Cloud','Project'],
        tech: ['AWS','Python','Chatbot','NodeJS'],
        description: 'A programmer tool to automate REST APIs creating CRUD operations out of the box based on the chat history and get the code via email.',
        fullDescription: [
            'The main focus is about stop doing the work which does not require much thinking and following the procedures would get the work done.',
            'Here the ideology is to work with rest apis using javascript.',
            'How great it would be when we just ask a person to create a project with standard CRUD apis and then give it to us in a way we can add more functions to it.'
        ],
        github: 'https://github.com/imprakashraghu/aws-programbuddy-bot'
    },
    {
        id: 5,
        extra: true,
        title: 'buglane',
        company: 'Personal Project',
        started: '2021',
        isCompleted: true,
        image: './buglane.png',
        ended: '2021',
        tags: ['Cloud','Project'],
        tech: ['Productivity','Browser Extension'],
        description: 'A little tool, Google Chrome Extension for tracking and managing bugs during development.',
        github: 'https://github.com/imprakashraghu/bug-lane-extension',
        link: 'https://chromewebstore.google.com/detail/bug-lane/bamihkkidbhdnioejfcdmpoppdicpnfe'
    },
]

function Projects() {
  return (
    <div className='w-full lg:w-[60%] mx-auto min-h-screen py-8 lg:py-10 px-6 lg:px-20 relative overflow-y-auto'>
        <SideBar />
        <div className='w-full mansory__ui'>
            {
                data
                ?.map(item => (
                    <ProjectItem
                        key={item?.id}
                        {...item}
                    />
                ))
            }
        </div>
        <p onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }} className='w-full text-right py-2 text-sm underline text-black cursor-pointer'>Back to top</p>
    </div>
  )
}

export default Projects